import { render, staticRenderFns } from "./EducationDetails.vue?vue&type=template&id=2193b543&"
import script from "./EducationDetails.vue?vue&type=script&lang=js&"
export * from "./EducationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports